import t from "js-cookie";
const i = (e) => {
  const o = t.get(e);
  return typeof o == "string" ? JSON.parse(o) : null;
}, n = (e, o, r) => t.set(e, JSON.stringify(o), { expires: r, secure: !0 }), c = (e) => t.remove(e);
export {
  i as getCookie,
  c as removeCookie,
  n as saveCookie
};
//# sourceMappingURL=index.js.map
